// except where specified, these are from
// https://creativecommons.org/licenses/?lang=ar

export const licenseTranslations = {
  ar: {
    'CC BY': {
      name: 'نَسب المُصنَّف',
      description:
        'هذه الرخصة تتيح للآخرين حرية إعادة التوزيع، التعديل، التغيير، والاشتقاق من عملك، سواء أكان ذلك لأغراض تجارية أو غير تجارية، طالما ينسبون العمل الأصلي لك. هذه هي الرخصة الأكثر تسامحاً في مجموعة الرخص المعروضة. وهي الأنسب لضمان أكبر انتشار واستخدام ممكن للمواد المرخَّصة.',
    },
    'CC BY-SA': {
      name: 'نَسب المُصنَّف - الترخيص بالمثل',
      description:
        'هذه الرخصة تتيح للآخرين حرية إعادة التوزيع، التعديل، التغيير، والاشتقاق من عملك، سواء أكان ذلك لأغراض تجارية أو غير تجارية، طالما ينسبون العمل الأصلي لك ويرخصون أعمالهم المشتقة تحت نفس الشروط. وهذه الرخصة غالباً تضاهي رخص "الحقوق المتروكة" للبرمجيات الحرة والمفتوحة المصدر. كل الأعمال المشتقة من عملك ستحمل نفس الرخصة، بالتالي جميع الأعمال المشتقة تسمح بالاستخدام التجاري. هذه الرخصة هي المستخدمة من قبل ويكيبيديا، وننصح بها للمواد التي قد تستفيد من الاشتقاق من ويكيبيديا والمشاريع المماثلة في الترخيص.',
    },
    'CC BY-ND': {
      name: 'نسب المصنف - منع الاشتقاق',
      // unofficial translation:
      description:
        'َهذه الرخصة تسمح بإعادة التوزیع، الاستخدام التجاري وغیر التجاري، بشرط عدم التعدیل، ون',
    },
    'CC BY-NC': {
      name: 'نسب المصنف - غير تجاري',
      description:
        'هذه الرخصة تتيح للآخرين حرية إعادة التوزيع، التعديل، التغيير، والاشتقاق من عملك في غير الأغراض التجارية، وبالرغم من أن الأعمال المشتقة يجب أن تنسب العمل الأصلي إليك وأن تكون غير تجارية، فإنه لا يلزم أن يتم ترخيصها بنفس الشروط.',
    },
    'CC BY-NC-SA': {
      name: 'نَسب المُصنَّف - غير تجاري - الترخيص بالمثل',
      description:
        'هذه الرخصة تتيح للآخرين التعديل، التحسين، وبناء نسخ مشتقة من المُصنَّف ولكن في غير الأغراض التجارية، بشرط نَسب العمل الأصلي إليك وترخيص الأعمال الجديدة بنفس الرخصة.',
    },
    'CC BY-NC-ND': {
      name: 'نَسب المُصنَّف - غير تجاري - منع الاشتقاق',
      description:
        'هذه الرخصة هي الأكثر قيوداً في رخصنا الستة الأساسية، إنها تتيح فقط للآخرين تحميل أعمالك ومشاركتها مع الآخرين بشرط نَسب العمل الأصلي إليك، ودون القيام بأي تعديل أو استخدامها لأغراض تجارية.',
    },
  },
  en: {
    'CC BY': {
      name: 'Attribution',
      description:
        'This license lets others distribute, remix, tweak, and build upon your work, even commercially, as long as they credit you for the original creation. This is the most accommodating of licenses offered. Recommended for maximum dissemination and use of licensed materials.',
    },
    'CC BY-SA': {
      name: 'Attribution-ShareAlike',
      description:
        'This license lets others remix, tweak, and build upon your work even for commercial purposes, as long as they credit you and license their new creations under the identical terms. This license is often compared to “copyleft” free and open source software licenses. All new works based on yours will carry the same license, so any derivatives will also allow commercial use. This is the license used by Wikipedia, and is recommended for materials that would benefit from incorporating content from Wikipedia and similarly licensed projects.',
    },
    'CC BY-ND': {
      name: 'Attribution-NoDerivs',
      description:
        'This license lets others reuse the work for any purpose, including commercially; however, it cannot be shared with others in adapted form, and credit must be provided to you.',
    },
    'CC BY-NC': {
      name: 'Attribution-NonCommercial',
      description:
        'This license lets others remix, tweak, and build upon your work non-commercially, and although their new works must also acknowledge you and be non-commercial, they don’t have to license their derivative works on the same terms.',
    },
    'CC BY-NC-SA': {
      name: 'Attribution-NonCommercial-ShareAlike',
      description:
        'This license lets others remix, tweak, and build upon your work non-commercially, as long as they credit you and license their new creations under the identical terms.',
    },
    'CC BY-NC-ND': {
      name: 'Attribution-NonCommercial-NoDerivs',
      description:
        'This license is the most restrictive of our six main licenses, only allowing others to download your works and share them with others as long as they credit you, but they can’t change them in any way or use them commercially.',
    },
  },
  'fr-fr': {
    'CC BY': {
      name: 'Attribution',
      description:
        'Cette licence permet aux autres de distribuer, remixer, arranger, et adapter votre œuvre, même à des fins commerciales, tant qu’on vous accorde le mérite de la création originale en citant votre nom. C’est le contrat le plus souple proposé. Recommandé pour la diffusion et l’utilisation maximales d’œuvres licenciées sous CC.',
    },
    'CC BY-SA': {
      name: 'Attribution - Partage dans les Mêmes Conditions',
      description:
        'Cette licence permet aux autres de remixer, arranger, et adapter votre œuvre, même à des fins commerciales, tant qu’on vous accorde le mérite en citant votre nom et qu’on diffuse les nouvelles créations selon des conditions identiques. Cette licence est souvent comparée aux licences de logiciels libres, “open source” ou “copyleft”. Toutes les nouvelles œuvres basées sur les vôtres auront la même licence, et toute œuvre dérivée pourra être utilisée même à des fins commerciales. C’est la licence utilisée par Wikipédia ; elle est recommandée pour des œuvres qui pourraient bénéficier de l’incorporation de contenu depuis Wikipédia et d’autres projets sous licence similaire.',
    },
    'CC BY-ND': {
      name: 'Attribution - Pas de Modification',
      description:
        'This license lets others reuse the work for any purpose, including commercially; however, it cannot be shared with others in adapted form, and credit must be provided to you.',
    },
    'CC BY-NC': {
      name: 'Attribution - Pas d’Utilisation Commerciale',
      description:
        'Cette licence permet aux autres de remixer, arranger, et adapter votre œuvre à des fins non commerciales et, bien que les nouvelles œuvres doivent vous créditer en citant votre nom et ne pas constituer une utilisation commerciale, elles n’ont pas à être diffusées selon les mêmes conditions.',
    },
    'CC BY-NC-SA': {
      name: 'Attribution - Pas d’Utilisation Commerciale - Partage dans les Mêmes Conditions',
      description:
        'Cette licence permet aux autres de remixer, arranger, et adapter votre œuvre à des fins non commerciales tant qu’on vous crédite en citant votre nom et que les nouvelles œuvres sont diffusées selon les mêmes conditions.',
    },
    'CC BY-NC-ND': {
      name: 'Attribution - Pas d’Utilisation Commerciale - Pas de Modification',
      description:
        'Cette licence est la plus restrictive de nos six licences principales, n’autorisant les autres qu’à télécharger vos œuvres et à les partager tant qu’on vous crédite en citant votre nom, mais on ne peut les modifier de quelque façon que ce soit ni les utiliser à des fins commerciales.',
    },
  },
  'es-es': {
    'CC BY': {
      name: 'Atribución',
      description:
        'Esta licencia permite a otras distribuir, remezclar, retocar, y crear a partir de su obra, incluso con fines comerciales, siempre y cuando den crédito por la creación original. Esta es la más flexible de las licencias ofrecidas. Se recomienda para la máxima difusión y utilización de los materiales licenciados.',
    },
    'CC BY-SA': {
      name: 'Atribución-CompartirIgual',
      description:
        'Esta licencia permite a otras remezclar, retocar, y crear a partir de su obra, incluso con fines comerciales, siempre y cuando den crédito y licencien sus nuevas creaciones bajo los mismos términos. Esta licencia suele ser comparada con las licencias «copyleft» de software libre y de código abierto. Todas las nuevas obras basadas en la suya portarán la misma licencia, así que cualesquiera obras derivadas permitirán también uso comercial. Esta es la licencia que usa Wikipedia, y se recomienda para materiales que se beneficiarían de incorporar contenido de Wikipedia y proyectos con licencias similares.',
    },
    'CC BY-ND': {
      name: 'Atribución-SinDerivadas',
      description:
        'This license lets others reuse the work for any purpose, including commercially; however, it cannot be shared with others in adapted form, and credit must be provided to you.',
    },
    'CC BY-NC': {
      name: 'Atribución-NoComercial',
      description:
        'Esta licencia permite a otras distribuir, remezclar, retocar, y crear a partir de su obra de forma no comercial y, a pesar de que sus nuevas obras deben siempre mencionarle y ser no comerciales, no están obligadas a licenciar sus obras derivadas bajo los mismos términos.',
    },
    'CC BY-NC-SA': {
      name: 'Atribución-NoComercial-CompartirIgual',
      description:
        'Esta licencia permite a otras remezclar, retocar, y crear a partir de su obra de forma no comercial, siempre y cuando den crédito y licencien sus nuevas creaciones bajo los mismos términos.',
    },
    'CC BY-NC-ND': {
      name: 'Atribución-NoComercial-SinDerivadas',
      description:
        'Esta licencia es la más restrictiva de nuestras seis licencias principales, permitiendo a otras sólo descargar sus obras y compartirlas con otras siempre y cuando den crédito, pero no pueden cambiarlas de forma alguna ni usarlas de forma comercial.',
    },
  },
  'pt-br': {
    'CC BY': {
      name: 'Atribuição',
      description:
        'Esta licença permite que outros distribuam, remixem, adaptem e criem a partir do seu trabalho, mesmo para fins comerciais, desde que lhe atribuam o devido crédito pela criação original. É a licença mais flexível de todas as licenças disponíveis. É recomendada para maximizar a disseminação e uso dos materiais licenciados.',
    },
    'CC BY-SA': {
      name: 'Atribuição-CompartilhaIgual',
      description:
        'Esta licença permite que outros remixem, adaptem e criem a partir do seu trabalho, mesmo para fins comerciais, desde que lhe atribuam o devido crédito e que licenciem as novas criações sob termos idênticos. Esta licença costuma ser comparada com as licenças de software livre e de código aberto "copyleft". Todos os trabalhos novos baseados no seu terão a mesma licença, portanto quaisquer trabalhos derivados também permitirão o uso comercial. Esta é a licença usada pela Wikipédia e é recomendada para materiais que seriam beneficiados com a incorporação de conteúdos da Wikipédia e de outros projetos com licenciamento semelhante.',
    },
    'CC BY-ND': {
      name: 'Atribuição-SemDerivações',
      description:
        'This license lets others reuse the work for any purpose, including commercially; however, it cannot be shared with others in adapted form, and credit must be provided to you.',
    },
    'CC BY-NC': {
      name: 'Atribuição-NãoComercial',
      description:
        'Esta licença permite que outros remixem, adaptem e criem a partir do seu trabalho para fins não comerciais, e embora os novos trabalhos tenham de lhe atribuir o devido crédito e não possam ser usados para fins comerciais, os usuários não têm de licenciar esses trabalhos derivados sob os mesmos termos.',
    },
    'CC BY-NC-SA': {
      name: 'Atribuição-NãoComercial-CompartilhaIgual',
      description:
        'Esta licença permite que outros remixem, adaptem e criem a partir do seu trabalho para fins não comerciais, desde que atribuam a você o devido crédito e que licenciem as novas criações sob termos idênticos.',
    },
    'CC BY-NC-ND': {
      name: 'Atribuição-SemDerivações-SemDerivados',
      description:
        'Esta é a mais restritiva das nossas seis licenças principais, só permitindo que outros façam download dos seus trabalhos e os compartilhem desde que atribuam crédito a você, mas sem que possam alterá-los de nenhuma forma ou utilizá-los para fins comerciais.',
    },
  },
};
